import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import type { Role } from "@/types";

export function RequireAuth() {
  const status = useAuthStore((s) => s.status);

  if (status === "loading") {
    return <div className="flex min-h-screen items-center justify-center text-slate-500">Cargando…</div>;
  }
  if (status === "guest") {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

export function RequireRole({ roles }: { roles: Role[] }) {
  const user = useAuthStore((s) => s.user);
  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }
  return <Outlet />;
}
